let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5ywns")).then(() => parcelRequire('1dEW4'));